import { Outlet, useLocation } from "react-router-dom";
import DashboardSidebar from "./DashboardSidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useEffect } from "react";

export default function DashboardLayout() {
  const isMobile = useIsMobile();
  const location = useLocation();

  useEffect(() => {
    // Force scroll to top with smooth behavior
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    // Also reset the scroll position of the main content
    const mainContent = document.querySelector('main');
    if (mainContent) {
      mainContent.scrollTop = 0;
    }
    // Reset body scroll
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [location.pathname]);
  
  return (
    <div className="fixed inset-0 flex flex-col md:flex-row bg-background overflow-hidden">
      <DashboardSidebar />
      <main className={`flex-1 overflow-y-auto ${isMobile ? "pt-16" : "p-6"} bg-background`}>
        {isMobile ? (
          <div className="p-4 pb-24">
            <Outlet />
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
